// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.asterisk {
  color: red;
  margin-left: 0.25rem;
}
`, "",{"version":3,"sources":["webpack://./src/Styles/LabeledInputWithAsterisk.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,oBAAoB;AACtB","sourcesContent":[".asterisk {\n  color: red;\n  margin-left: 0.25rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
